module.exports = __webpack_public_path__ + "img/37.4153b2c4.jpg";